<template>
  <div class="main-container">
    <div class="main-container-title">
      <div class="d-flex">
        <v-btn
          @click="back"
          style="width: auto !important"
          class="button-accept"
        >
          <v-icon>mdi-chevron-left</v-icon>
          Вернуться к списку чатов
        </v-btn>
        <div class="main-container-title-text">
          <template v-if="modeAll"> Все чаты </template>
          <template v-else>
            {{ chat?.title }}
          </template>
        </div>
      </div>
      <v-btn
        @click="dialogReference = true"
        outlined
        style="width: 135px !important"
        color="var(--app-dark-blue-1)"
        class="button-accept-outlined"
      >
        Справка
      </v-btn>
    </div>

    <div class="container-chat">
      <transition name="slide-pinned">
        <div
          class="container-chat-message-fixed d-flex"
          v-if="fixedMessage && !modeAll"
          @click="scrollToPinedMess"
        >
          <div
            class="message-fixed-image mr-0"
            v-if="fixedMessage.attachments.length > 0"
          >
            <div
              class="message-fixed-image"
              v-for="(att, ind) in fixedMessage.attachments.filter(
                (i) => i.type == 'image'
              )"
              :key="ind"
            >
              <img style="" :src="att.body" />
            </div>
          </div>
          <div>
            <div class="message-fixed-title">Закрепленное сообщение</div>
            <div class="message-fixed-text">
              {{ fixedMessage.body }}
            </div>
          </div>
        </div>
      </transition>

      <div class="container-chat-date-block">
        <div :class="isScrolling ? 'date-block' : 'date-block-hide'">
          {{ dateInDateBlock }}
        </div>
      </div>

      <div
        class="container-chat-messages"
        ref="scrollChats"
        @scroll="scrollMethod"
        :style="
          userRoleEdit && !modeAll
            ? 'height: calc(100vh - 240px);'
            : 'height: calc(100vh - 156px);'
        "
      >
        <div
          v-for="(pack, i) in viewArray"
          :key="pack.packNumber"
          ref="scrollBlock"
        >
          <div v-show="pack.show" :key="i">
            <div 
              v-for="(item, index) in pack.messages" 
              :key="item.id"
              class="container-chat-messages__item" 
              :data-read="item.isRead" 
              :data-id="item.id" 
            >
              <ChatCard
                :item="item"
                :index="index"
                :pack="pack"
                :allPacks="allPacks"
                :firstNotReadMessage="firstNotReadMessage"
                @update:firstNotReadMessage="
                  (v) => {
                    if (!firstNotReadMessage) firstNotReadMessage = v;
                  }
                "
                :modeAll="modeAll"
                :userRoleEdit="userRoleEdit"
                :showAnswerIcon="showAnswerIcon"
                :fixedMessage="fixedMessage"
                @openDialogFixed="openDialogFixed"
                @openDialogBlockUser="openDialogBlockUser"
                @openDialogImg="openDialogImg"
                @blockMessage="blockMessage"
                @addAnswer="addAnswer"
                @editMessage="editMessage"
              />
            </div>
          </div>
        </div>
        <div class="chat-messages-bottom" @click="goToBottom" v-if="notBottom">
          <v-icon color="var(--app-dark-blue-1)">mdi-chevron-down</v-icon>
        </div>
      </div>

      <div v-if="userRoleEdit && !modeAll" class="container-chat-send-message">
        <transition name="slide-input">
          <div v-if="answerObj" class="send-message-answer">
            <div class="send-message-answer-icon">
              <v-icon color="#1064DD" size="24"> mdi-reply </v-icon>
            </div>
            <div class="send-message-answer-value">
              <div v-if="answerObj.attachments.length > 0">
                <div
                  v-for="(atta, ind) in answerObj.attachments.filter(
                    (i) => i.type == 'image'
                  )"
                  :key="ind"
                  class="answer-value-image"
                >
                  <img :src="atta.body" />
                </div>
              </div>
              <div class="answer-value-text">
                <div>
                  Ответить
                  {{
                    answerObj.userWriter
                      ? checkWriterName(answerObj.userWriter)
                      : checkWriterName(answerObj.adminPanelUserWriter)
                  }}
                </div>

                <div v-if="answerObj.body">{{ answerObj.body }}</div>
                <div
                  v-else-if="
                    answerObj.attachments.length > 0 &&
                    answerObj.attachments[0].type == 'image'
                  "
                >
                  Изображение
                </div>
                <div
                  v-else-if="
                    answerObj.attachments.length > 0 &&
                    answerObj.attachments[0].type == 'transition'
                  "
                >
                  <span class="d-flex">
                    <span class="mr-2">
                      <v-icon color="var(--app-dark-blue-1)" size="16">
                        mdi-arrow-right-top
                      </v-icon>
                    </span>
                    <span style="color: var(--app-dark-blue-1)">
                      {{ JSON.parse(answerObj.attachments[0].body).buttonName }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <transition name="slide-input">
          <div v-if="editMessageItem.id">
            <div class="send-message-answer">
              <div class="send-message-answer-icon">
                <v-icon color="#1064DD" size="24"> mdi-pencil-outline </v-icon>
              </div>
              <div class="send-message-answer-value">
                <div class="answer-value-text">
                  <div>Редактирование</div>
                  <div v-if="editMessageItem.oldBody">
                    {{ editMessageItem.oldBody }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="editMessageItem.attachments.length > 0">
              <div
                v-for="(atta, ind) in editMessageItem.attachments.filter(
                  (i) => i.type == 'image'
                )"
                :key="ind"
                class="send-message-answer"
              >
                <div class="send-message-answer-icon">
                  <v-icon color="#1064DD" size="24"> mdi-image-outline </v-icon>
                </div>
                <div class="send-message-answer-value">
                  <div
                    v-if="atta.newImage"
                    @click="openDialogImg(atta.newImage)"
                    class="answer-value-image"
                  >
                    <img :src="atta.newImage" />
                  </div>
                  <div class="answer-value-text">
                    <div v-if="typeof atta.attachments[0] === 'object'">
                      {{ atta.attachments[0].name }}
                    </div>
                    <div v-else>Изображение</div>
                  </div>
                </div>
                <div
                  style="cursor: pointer"
                  @click="
                    editMessageItem.attachments =
                      editMessageItem.attachments.filter((i) => i.id != atta.id)
                  "
                >
                  <v-icon> mdi-close </v-icon>
                </div>
              </div>
              <div
                v-for="(atta, ind) in editMessageItem.attachments.filter(
                  (i) => i.type == 'transition'
                )"
                :key="ind + 1000"
                class="send-message-answer"
              >
                <div class="send-message-answer-icon">
                  <v-icon color="#1064DD" size="24"> mdi-link </v-icon>
                </div>
                <div class="send-message-answer-value" style="min-height: 40px">
                  <div class="answer-value-text">
                    <div>
                      {{ atta.name }}
                    </div>
                  </div>
                </div>
                <div
                  style="cursor: pointer"
                  @click="
                    editMessageItem.attachments =
                      editMessageItem.attachments.filter((i) => i.id != atta.id)
                  "
                >
                  <v-icon> mdi-close </v-icon>
                </div>
              </div>
            </div>
          </div>
          <div v-if="sendMessage.attachments.length > 0">
            <div
              v-for="(atta, ind) in sendMessage.attachments.filter(
                (i) => i.type == 'image'
              )"
              :key="ind"
              class="send-message-answer"
            >
              <div class="send-message-answer-icon">
                <v-icon color="#1064DD" size="24"> mdi-image-outline </v-icon>
              </div>
              <div class="send-message-answer-value">
                <div
                  v-if="atta.newImage"
                  @click="openDialogImg(atta.newImage)"
                  class="answer-value-image"
                >
                  <img :src="atta.newImage" />
                </div>
                <div class="answer-value-text">
                  <div v-if="typeof atta.attachments[0] === 'object'">
                    {{ atta.attachments[0].name }}
                  </div>
                  <div v-else>Изображение</div>
                </div>
              </div>
              <div
                style="cursor: pointer"
                @click="
                  sendMessage.attachments = sendMessage.attachments.filter(
                    (i) => i.id != atta.id
                  )
                "
              >
                <v-icon> mdi-close </v-icon>
              </div>
            </div>
            <div
              v-for="(atta, ind) in sendMessage.attachments.filter(
                (i) => i.type == 'transition'
              )"
              :key="ind + 1000"
              class="send-message-answer"
            >
              <div class="send-message-answer-icon">
                <v-icon color="#1064DD" size="24"> mdi-link </v-icon>
              </div>
              <div class="send-message-answer-value" style="min-height: 40px">
                <div class="answer-value-text">
                  <div>
                    {{ atta.name }}
                  </div>
                </div>
              </div>
              <div
                style="cursor: pointer"
                @click="
                  sendMessage.attachments = sendMessage.attachments.filter(
                    (i) => i.name != atta.name
                  )
                "
              >
                <v-icon> mdi-close </v-icon>
              </div>
            </div>
          </div>
        </transition>
        <div class="send-message-block">
          <div @click="openMenuInput($event)">
            <v-icon>mdi-paperclip</v-icon>
          </div>
          <v-menu
            v-model="showInfo"
            :position-x="x"
            :position-y="y"
            top
            absolute
          >
            <div class="contextmenu-chat">
              <div class="contextmenu-chat-item" @click="ckickInput">
                Изображение
              </div>
              <div class="contextmenu-chat-item" @click="dialogLink = true">
                Ссылка
              </div>
            </div>
          </v-menu>
          <input
            accept="image/jpeg,image/png, image/jpg"
            ref="uploader"
            class="d-none"
            type="file"
            :value="inputValue"
            @change="changeInput"
          />

          <textarea
            v-if="editMessageItem.id"
            :rows="rowsNumber"
            ref="input"
            v-model="editMessageItem.body"
            class="send-message-block-input"
            type="text"
            placeholder="Сообщение…"
          />

          <textarea
            v-else
            :rows="rowsNumber"
            ref="input"
            v-model="sendMessage.body"
            class="send-message-block-input"
            type="text"
            placeholder="Сообщение…"
          />
          <v-btn
            @click="dialogSendMessage = true"
            :disabled="checkDisable"
            style="width: 135px !important"
            color="var(--app-dark-blue-1)"
            class="button-accept"
          >
            Отправить
          </v-btn>
          <v-btn
            v-if="editMessageItem.id"
            @click="closeEditInput"
            depressed
            outlined
            style="width: 135px !important"
            color="var(--app-dark-blue-1)"
            class="button-accept-outlined ml-8"
          >
            Отмена
          </v-btn>
          <v-btn
            v-if="answerObj"
            @click="closeAnswer"
            depressed
            outlined
            style="width: 135px !important"
            color="var(--app-dark-blue-1)"
            class="button-accept-outlined ml-8"
          >
            Отмена
          </v-btn>
        </div>
      </div>
    </div>

    <v-dialog width="570px" height="auto" persistent v-model="dialogBlockUser">
      <v-card width="570px" height="auto" class="rounded-0">
        <v-form ref="formFirst">
          <v-card-title class="dialog-title">
            <span
              class="title"
              v-if="
                selectedUser.userWriter && selectedUser.userWriter.isBlocked
              "
            >
              Раблокировать пользователя?
            </span>
            <span v-else class="title">Заблокировать пользователя?</span>
            <v-icon @click="closeDialog">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-description-icon-block mb-10">
              <img
                :src="
                  selectedUser.userWriter ? selectedUser.userWriter.photo : ''
                "
              />
              <div>
                {{
                  selectedUser.userWriter
                    ? checkWriterName(selectedUser.userWriter)
                    : ""
                }}
              </div>
            </div>

            <v-select
              v-if="
                selectedUser.userWriter && !selectedUser.userWriter.isBlocked
              "
              :items="reasonsBlock"
              outlined
              item-text="title"
              item-value="id"
              :rules="[(v) => !!(v && v.length) || 'Обязательно к заполнению']"
              v-model="selectedUser.reasonBlock"
              label="Выберите причину"
            ></v-select>
          </v-card-text>
          <v-card-actions
            class="dialog-buttons"
            style="padding-top: 0px !important"
          >
            <v-btn
              @click="closeDialog"
              outlined
              style="width: 100px !important"
              color="var(--app-dark-blue-1)"
              class="button-accept-outlined"
            >
              Отмена
            </v-btn>
            <v-btn
              :loading="blockingLoad"
              v-if="
                selectedUser.userWriter && !selectedUser.userWriter.isBlocked
              "
              @click="blockingUser(true)"
              outlined
              style="width: 160px !important"
              color="var(--app-red-1)"
              class="button-accept-outlined"
            >
              Заблокировать
            </v-btn>
            <v-btn
              :loading="blockingLoad"
              v-else
              @click="blockingUser(false)"
              outlined
              style="width: 160px !important"
              color="var(--app-green-1)"
              class="button-accept-outlined"
            >
              Раблокировать
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      width="570px"
      height="auto"
      persistent
      v-model="dialogSendMessage"
    >
      <v-card width="570px" height="auto" class="rounded-0">
        <v-card-title class="dialog-title">
          <span class="title"
            ><span style="color: var(--app-red-1)">Внимание!</span> Сообщение
            будет <br />отправлено от имени Банка.</span
          >
          <v-icon @click="dialogSendMessage = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="dialog-description">
          <div
            class="dialog-description-text-container"
            style="color: #929292"
            v-if="sendMessage.body || editMessageItem.body"
          >
            Текст сообщения
          </div>
          <div
            class="dialog-description-text-container"
            style="white-space: pre-wrap"
            v-if="sendMessage.body || editMessageItem.body"
          >
            {{ sendMessage.body ? sendMessage.body : "" }}
            {{ editMessageItem.body ? editMessageItem.body : "" }}
          </div>
          <div
            v-if="
              sendMessage.attachments.length > 0 &&
              findAttaType(sendMessage.attachments, 'image').length > 0
            "
            class="dialog-description-text-container"
            style="color: #929292"
          >
            Изображение
          </div>
          <div
            v-if="
              sendMessage.attachments.length > 0 &&
              findAttaType(sendMessage.attachments, 'image').length > 0
            "
            class="d-flex"
          >
            <div
              class="dialog-images"
              v-for="(img, ind) in findAttaType(
                sendMessage.attachments,
                'image'
              )"
              :key="ind"
            >
              <img class="dialog-images-object" :src="img.newImage" />
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="dialog-buttons">
          <v-btn
            @click="dialogSendMessage = false"
            :disabled="isSendMessage"
            outlined
            style="width: 100px !important"
            color="var(--app-dark-blue-1)"
            class="button-accept-outlined"
          >
            Отмена
          </v-btn>
          <v-btn
            @click="sendMessageMethod"
            :loading="isSendMessage"
            outlined
            style="width: 135px !important"
            color="var(--app-dark-blue-1)"
            class="button-accept-outlined"
          >
            Отправить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="570px" height="auto" persistent v-model="dialogFixed">
      <v-card width="570px" height="auto" class="rounded-0">
        <v-card-title class="dialog-title">
          <span class="title">
            <span style="color: var(--app-red-1)">Внимание!</span> Закрепленное
            <br />
            сообщение будет
            <span v-if="fixedMessage && featureFixed.id == fixedMessage.id"
              >открепленно.</span
            >
            <span v-else>изменено.</span>
          </span>
          <v-icon @click="dialogFixed = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="dialog-description">
          <div
            v-if="featureFixed.body"
            class="dialog-description-text-container"
            style="color: #929292"
          >
            Текст сообщения
          </div>
          <div
            class="dialog-description-text-container"
            style="margin-bottom: 12px"
          >
            {{ featureFixed.body }}
          </div>
        </v-card-text>
        <v-card-actions class="dialog-buttons">
          <v-btn
            @click="dialogFixed = false"
            outlined
            style="width: 100px !important"
            color="var(--app-dark-blue-1)"
            class="button-accept-outlined"
          >
            Отмена
          </v-btn>
          <v-btn
            @click="fixedNewMessage(false)"
            v-if="fixedMessage && featureFixed.id == fixedMessage.id"
            outlined
            style="width: 135px !important"
            color="var(--app-dark-blue-1)"
            class="button-accept-outlined"
          >
            Открепить
          </v-btn>
          <v-btn
            v-else
            @click="fixedNewMessage(true)"
            outlined
            style="width: 135px !important"
            color="var(--app-dark-blue-1)"
            class="button-accept-outlined"
          >
            Закрепить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="400px" height="auto" persistent v-model="dialogReference">
      <v-card width="400px" height="auto" class="rounded-0">
        <v-card-title class="dialog-title">
          <span class="title">Справка</span>
          <v-icon @click="dialogReference = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="dialog-description">
          <div class="mb-6">
            <div
              class="dialog-description-text-container mb-1"
              style="color: #929292"
            >
              Иконка <v-icon class="ml-1">mdi-lock-open</v-icon>
            </div>
            <div class="dialog-description-text-container">
              Разблокированное сообщение
            </div>
          </div>
          <div class="mb-6">
            <div
              class="dialog-description-text-container mb-1"
              style="color: #929292"
            >
              Иконка <v-icon class="ml-2">mdi-lock</v-icon>
            </div>
            <div class="dialog-description-text-container">
              Заблокированное сообщение
            </div>
          </div>

          <div class="mb-6">
            <div
              class="dialog-description-text-container mb-1 d-flex align-center"
              style="color: #929292"
            >
              Иконка
              <img
                style="width: 24px; height: 24px"
                class="ml-2"
                src="../../../src/assets/lockAuto.svg"
              />
            </div>
            <div class="dialog-description-text-container">
              Автоматически заблокированное сообщение - нельзя разблокировать
            </div>
          </div>
          <div class="mb-6">
            <div
              class="dialog-description-text-container mb-1"
              style="color: #929292"
            >
              Иконка <v-icon class="ml-2">mdi-pin</v-icon>
            </div>
            <div class="dialog-description-text-container">
              Закрепить сообщение
            </div>
          </div>
          <div class="mb-6">
            <div
              class="dialog-description-text-container mb-1"
              style="color: #929292"
            >
              Иконка <v-icon class="ml-2">mdi-reply</v-icon>
            </div>
            <div class="dialog-description-text-container">
              Ответить на сообщение, которое навели
            </div>
          </div>
          <div class="mb-6">
            <div
              class="dialog-description-text-container mb-1"
              style="color: #929292"
            >
              Иконка <v-icon class="ml-2">mdi-dots-horizontal</v-icon>
            </div>
            <div class="dialog-description-text-container">
              Возможность редактирования и скрытия сообщения (только для
              сообщений сотрудников банка)
            </div>
          </div>
          <div class="mb-6">
            <div
              class="dialog-description-text-container mb-1"
              style="color: #929292"
            >
              Клик на фото пользователя
            </div>
            <div class="dialog-description-text-container">
              Возможность блокировки пользователя
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="570px" height="auto" persistent v-model="dialogAddImage">
      <v-card width="570px" height="auto" class="rounded-0">
        <v-card-title class="dialog-title" style="border: none !important">
          <span class="title"></span>
          <v-icon @click="closeDialogImage">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="dialog-description">
          <div class="d-flex align-center justify-center">
            <img
              @click="openDialogImg(newImage)"
              class="dialog-description-img"
              :src="newImage"
            />
          </div>
        </v-card-text>
        <v-card-actions class="dialog-buttons">
          <textarea
            v-if="editMessageItem.id"
            :rows="rowsNumber"
            ref="input"
            v-model="editMessageItem.bodyImage"
            class="dialog-buttons-input"
            type="text"
            placeholder="Сообщение…"
          />
          <textarea
            v-else
            :rows="rowsNumber"
            ref="input"
            v-model="sendMessage.bodyImage"
            class="dialog-buttons-input"
            type="text"
            placeholder="Сообщение…"
          />
          <v-btn
            @click="dialogSendMessage = true"
            outlined
            style="width: 135px !important"
            color="var(--app-dark-blue-1)"
            class="button-accept-outlined"
          >
            Отправить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      width="600px"
      height="auto"
      persistent
      v-model="dialogDeleteOldImage"
    >
      <v-card>
        <v-card-title class="dialog-title">
          <span class="title">Точно хотите скрыть сообщение ?</span>
          <v-icon @click="dialogDeleteOldImage = false">mdi-close</v-icon>
        </v-card-title>
        <!-- <v-card-text class="dialog-description">
          <div class="dialog-description-text-container">
            Если вы удалите изображение, сообщение будет скрыто.
          </div>
        </v-card-text> -->

        <v-card-actions class="dialog-buttons">
          <v-btn
            @click="dialogDeleteOldImage = false"
            style="width: 120px"
            outlined
            color="var(--app-green-1)"
          >
            Нет
          </v-btn>
          <v-btn
            @click="deleteOldMethod"
            style="width: 120px"
            outlined
            color="var(--app-red-1)"
          >
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="700px" height="auto" persistent v-model="dialogLink">
      <v-card>
        <v-card-title class="dialog-title">
          <span class="title">Добавить ссылку</span>
          <v-icon @click="closeDialogLink">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="dialog-description">
          <v-form lazy-validation ref="formTest">
            <v-text-field
              label="Название ссылки"
              required
              type="text"
              outlined
              :rules="[(v) => !!v || 'Обязательно к заполнению']"
              v-model="transition.buttonName"
            ></v-text-field>

            <div>
              <TransitionObj
                v-model="transition"
                :hideTypes="['null', 'file', 'page']"
                ref="transition"
              />
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions class="dialog-buttons">
          <v-btn
            @click="addTransitionToMessage"
            style="width: 135px !important"
            color="var(--app-dark-blue-1)"
            class="button-accept"
          >
            Добавить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogImage v-model="dialogImg" :src="previewImage" />
  </div>
</template>
<script>
import ChatCard from "@/components/main/chat/ChatBlock";
import TransitionObj from "@/components/main/Transition";
export default {
  components: {
    ChatCard,
    TransitionObj,
  },
  data: () => ({
    transition: {},
    userRoleEdit: false,
    modeAll: false,
    allPacks: [],
    reasonsBlock: [],
    chat: {},
    fixedMessage: null,
    featureFixed: {},
    dialogBlockUser: false,
    dialogSendMessage: false,
    dialogReference: false,
    dialogFixed: false,
    dialogAddImage: false,
    dialogDeleteOldImage: false,
    selectedUser: {},
    answerObj: null,
    rowsNumber: 1,
    sendMessage: {
      body: "",
      attachments: [],
    },
    editMessageItem: {
      body: "",
      attachments: [],
    },
    dialogImg: false,
    dialogLink: false,
    previewImage: null,
    imageWidth: 0,
    notBottom: false,
    lastNumberPack: null,
    numberPacks: [],
    firstLoadPage: true,
    loadPack: false,
    firstNotReadMessage: null,
    connection: "",
    isSendMessage: false,
    // menuBank: false,
    lastReadMessageId: "",
    observer: null,
    blockingLoad: false,
    monthItems: [
      { name: "января", number: "01" },
      { name: "февраля", number: "02" },
      { name: "марта", number: "03" },
      { name: "апреля", number: "04" },
      { name: "мая", number: "05" },
      { name: "июня", number: "06" },
      { name: "июля", number: "07" },
      { name: "августа", number: "08" },
      { name: "сентября", number: "09" },
      { name: "октября", number: "10" },
      { name: "ноября", number: "11" },
      { name: "декабря", number: "12" },
    ],
    isScrolling: false,
    showAnswerIcon: true,
    dateInDateBlock: "",
    newImage: null,
    oldImage: null,
    inputValue: "",
    viewArray: [],
    showInfo: false,
    x: null,
    y: null,
  }),
  computed: {
    checkDisable() {
      if (this.editMessageItem.id) {
        if (
          this.editMessageItem.body.length == 0 &&
          this.editMessageItem.attachments.length == 0
        ) {
          return true;
        }
        return false;
      } else {
        if (
          this.sendMessage.body.length == 0 &&
          this.sendMessage.attachments.length == 0
        ) {
          return true;
        }
        return false;
      }
    },
  },

  methods: {
    closeDialogLink() {
      this.dialogLink = false;
      this.$refs.formTest.reset();
      this.$refs.formTest.resetValidation();
    },
    addTransitionToMessage() {
      if (
        this.$refs.formTest.validate() &&
        this.$refs.transition.validMethod()
      ) {
        const newObj = {
          body: JSON.parse(JSON.stringify(this.transition)),
          type: "transition",
          name: this.transition.buttonName,
        };
        if (this.editMessageItem.id) {
          this.editMessageItem.attachments =
            this.editMessageItem.attachments.filter(
              (i) => i.type != "transition"
            );
          this.editMessageItem.attachments.push(newObj);
        } else {
          this.sendMessage.attachments = this.sendMessage.attachments.filter(
            (i) => i.type != "transition"
          );
          this.sendMessage.attachments.push(newObj);
        }

        this.closeDialogLink();
      }
    },
    findAttaType(list, type) {
      const arr = list.filter((i) => i.type == type);
      return arr;
    },

    openMenuInput(e) {
      e.preventDefault();
      this.x = e.clientX + 20;
      this.y = e.clientY;
      this.showInfo = true;
    },
    getVisibleElements(container, elements) {
      if (!container) return;
      const containerTop = container.scrollTop;
      const containerBottom = containerTop + container.clientHeight;
      return Array.from(elements).filter((element) => {
        const elementTop = element.offsetTop;
        const elementBottom = elementTop + element.offsetHeight;
      return (
        (elementTop >= containerTop && elementTop < containerBottom) ||
        (elementBottom > containerTop && elementBottom <= containerBottom) ||
        (elementTop < containerTop && elementBottom > containerBottom)
        );
      }).map(element => ({
        id: element.attributes['data-id']?.value, isRead: Boolean(element.attributes['data-read']?.value)
      }));
    },
    readVisibleMessages() {
      this.getVisibleElements(
        this.$refs.scrollChats, document.querySelectorAll('.container-chat-messages__item')
      ).forEach((element) => {
        if (!element.isRead) {
          this.readMessage(element.id);
        }
      })
    },
    scrollMethod(e) {
      if (!this.firstLoadPage) {
        const scrollTop = e.target.scrollTop;
        const scrollHeight = e.target.scrollHeight - e.target.clientHeight;
        const messages = document.getElementsByClassName("chat-messages-block");
        if (scrollTop < scrollHeight / 2) {
          const postPack = this.viewArray[0].packNumber - 1;
          if (postPack > 0) {
            if (!this.loadPack) {
              if (!this.numberPacks.includes(postPack)) {
                this.loadPack = true;
                this.getNewPack(postPack);
              } else if (
                this.numberPacks.includes(postPack) &&
                scrollTop < scrollHeight / 5
              ) {
                const findPack = this.allPacks.find(
                  (i) => i.packNumber == postPack
                );
                let height;
                for (let index = 0; index < messages.length; index++) {
                  const element = messages[index];
                  const neededNumber = this.viewArray[0].packNumber;
                  if (
                    neededNumber == parseInt(element.attributes.data_pack.value)
                  ) {
                    height = element.offsetTop;
                  }
                }
                this.viewArray.unshift(findPack);
                this.$nextTick(() => {
                  if (!this.chrome) {
                    this.$refs.scrollChats.scrollTop = height + scrollTop;
                  }
                });
              }
            }
          }
          if (!this.loadPack && this.viewArray.length > 4) {
            this.viewArray.pop();
          }
        }
        if (scrollTop > scrollHeight / 2) {
          const nextPack =
            this.viewArray[this.viewArray.length - 1].packNumber + 1;

          if (nextPack <= this.allPacks.length) {
            if (!this.loadPack) {
              if (!this.numberPacks.includes(nextPack)) {
                this.loadPack = true;
                this.getNewPack(nextPack);
              } else if (
                this.numberPacks.includes(nextPack) &&
                scrollTop > scrollHeight - scrollHeight / 3
              ) {
                const findPack = this.allPacks.find(
                  (i) => i.packNumber == nextPack
                );
                this.viewArray.push(findPack);
              }
            }
          }
          if (!this.loadPack && this.viewArray.length > 4) {
            this.viewArray.shift();
            this.$nextTick(() => {
              if (scrollTop - (scrollHeight - scrollTop) == scrollTop) {
                this.$refs.scrollChats.scrollTop = scrollTop - 1000;
              } else {
                this.$refs.scrollChats.scrollTop =
                  scrollTop - (scrollHeight - scrollTop);
              }
            });
          }
        }
        this.readVisibleMessages();
        if (scrollTop + 200 > scrollHeight) {
          this.notBottom = false;
        } else {
          this.notBottom = true;
        }

        setTimeout(() => {
          this.addObserver();
        }, 300);
      }
    },
    getNewPack(number) {
      const url = this.modeAll
        ? "/club/chat/message/getAll"
        : "/club/chat/message/list";
      this.$axios
        .get(this.$store.getters.apiAdminPanelV2 + url, {
          params: {
            chatId: this.modeAll ? "" : this.$route.params.id,
            packNumber: number,
          },
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
        })
        .then((res) => {
          let newArr = [];
          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index];
            const newItems = element.messages.map((i) => ({
              ...i,
              answerShow: false,
            }));
            element.messages = newItems;
            newArr.push(element);
          }
          for (let index = 0; index < this.allPacks.length; index++) {
            const element = this.allPacks[index];
            if (newArr[0].packNumber == element.packNumber) {
              element.messages = newArr[0].messages;
              element.show = true;
            }
          }
          this.numberPacks.push(res.data[0].packNumber);
          this.loadPack = false;
        });
    },
    openDialogImg(src) {
      this.previewImage = src;
      this.dialogImg = true;
    },
    closeAnswer() {
      this.answerObj = null;
      this.closeBlockEditAnswer();
    },
    closeBlockEditAnswer() {
      const newScrollTop = JSON.parse(
        JSON.stringify(this.$refs.scrollChats.scrollTop)
      );
      for (let index = 0; index < 200; index++) {
        let ind = 60;
        if (Number.isInteger(index / 10)) {
          let number = ind * (index / 200);
          setTimeout(() => {
            this.$refs.scrollChats.scrollTop = newScrollTop - number;
          }, index);
        }
      }
    },
    openBlockEditAnswer(bool) {
      const newScrollTop = JSON.parse(
        JSON.stringify(this.$refs.scrollChats.scrollTop)
      );
      if (!bool) {
        for (let index = 0; index < 200; index++) {
          let ind = 70;
          if (Number.isInteger(index / 10)) {
            let number = ind * (index / 200);
            setTimeout(() => {
              this.$refs.scrollChats.scrollTop = newScrollTop + number;
            }, index);
          }
        }
      }
    },
    addAnswer(item) {
      let bool = this.answerObj ? true : false;
      this.answerObj = item;

      (this.editMessageItem = {
        body: "",
        attachments: [],
      }),
        (this.oldImage = null);
      this.openBlockEditAnswer(bool);
    },
    closeEditInput() {
      this.editMessageItem = {
        body: "",
        attachments: [],
      };
      this.newImage = null;
      this.oldImage = null;
      this.closeBlockEditAnswer();
    },
    deleteOldImage() {
      if (this.editMessageItem.body && this.editMessageItem.body.length > 0) {
        this.oldImage = null;
      } else {
        this.dialogDeleteOldImage = true;
      }
    },

    ckickInput() {
      this.$refs.uploader.click();
    },
    qualityRate(fileSize) {
      let QUALITY = 0.9;
      if (1000000 > fileSize) {
        QUALITY = 0.8;
      } else if (3000000 > fileSize) {
        QUALITY = 0.7;
      } else if (5000000 > fileSize) {
        QUALITY = 0.5;
      } else if (10000000 > fileSize) {
        QUALITY = 0.3;
      } else {
        QUALITY = 0.2;
      }
      return QUALITY;
    },
    changeInput(e) {
      if (e.target.files[0]) {
        const file = e.target.files[0];
        const type = file.type;
        const name = file.name;
        const blobURL = URL.createObjectURL(e.target.files[0]);
        const img = new Image();

        img.src = blobURL;
        let vm = this;
        img.onload = function () {
          URL.revokeObjectURL(this.src);
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const quality = vm.qualityRate(file.size);

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, img.width, img.height);

          canvas.toBlob(
            (blob) => {
              let localfile = new File(
                [blob],
                name,
                { type: type, lastModified: new Date().getTime() },
                "utf-8"
              );
              const resolution = {
                width: img.width,
                height: img.height,
              };
              if (vm.editMessageItem.id) {
                vm.editMessageItem.attachments =
                  vm.editMessageItem.attachments.filter(
                    (i) => i.type != "image"
                  );
                const newObj = {
                  attachments: [],
                  resolutions: [],
                  type: "image",
                  id: Math.floor(Math.random() * 1000),
                  newImage: URL.createObjectURL(localfile),
                };
                newObj.attachments.push(localfile);
                newObj.resolutions.push(resolution);
                vm.editMessageItem.attachments.push(newObj);
                vm.editMessageItem.body = vm.editMessageItem.body
                  ? vm.editMessageItem.body
                  : "";
              } else {
                vm.sendMessage.attachments = vm.sendMessage.attachments.filter(
                  (i) => i.type != "image"
                );
                const newObj = {
                  attachments: [],
                  resolutions: [],
                  type: "image",
                  id: Math.floor(Math.random() * 1000),
                  newImage: URL.createObjectURL(localfile),
                };
                newObj.attachments.push(localfile);
                newObj.resolutions.push(resolution);
                vm.sendMessage.attachments.push(newObj);
                vm.sendMessage.body = vm.sendMessage.body
                  ? vm.sendMessage.body
                  : "";
                vm.openBlockEditAnswer(false);
              }
            },
            type,
            quality
          );
        };
      }
    },
    editMessage(item) {
      if (this.editMessageItem.id) {
        this.openBlockEditAnswer(true);
      } else {
        this.openBlockEditAnswer(false);
      }
      this.editMessageItem = {
        id: item.id,
        oldBody: item.body,
        body: item.body,
        attachments: [],
      };
      if (item.attachments.length > 0) {
        item.attachments.forEach((element) => {
          if (element.type == "image") {
            const newObj = {
              attachments: [],
              resolutions: [],
              type: "image",
              id: Math.floor(Math.random() * 1000),
              newImage: element.body,
            };
            const oldAtt = {
              data: {
                url: element.body,
                features: element.features,
              },
              type: "image",
            };
            newObj.attachments.push(JSON.stringify(oldAtt));
            this.editMessageItem.attachments.push(newObj);
          } else if (element.type == "transition") {
            const newObj = {
              name: JSON.parse(element.body).buttonName,
              body: JSON.parse(element.body),
              type: element.type,
              id: element.id,
            };
            this.editMessageItem.attachments.push(newObj);
          }
        });
      }
      this.answerObj = null;
    },
    closeDialogImage() {
      this.dialogAddImage = false;
      if (this.editMessageItem.id) {
        this.newImage = null;
        this.inputValue = "";
        this.editMessageItem.bodyImage
          ? (this.editMessageItem.body = this.editMessageItem.bodyImage)
          : "";
      } else {
        this.newImage = null;
        this.inputValue = "";
        this.sendMessage.bodyImage
          ? (this.sendMessage.body = this.sendMessage.bodyImage)
          : "";
      }
    },

    back() {
      this.$router.push({ name: "ChatList" });
    },
    openDialogBlockUser(item) {
      this.selectedUser = item;
      this.dialogBlockUser = true;
    },
    openDialogFixed(item) {
      this.featureFixed = Object.assign({}, item);
      this.dialogFixed = true;
    },
    fixedNewMessage(bool) {
      this.$axios
        .put(
          this.$store.getters.apiAdminPanelV2 + "/club/chat/message/pin",
          {
            messageId: this.featureFixed.id,
            toPin: bool,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.dialogFixed = false;
          if (bool) {
            this.fixedMessage = this.featureFixed;
          } else {
            this.featureFixed = {};
            this.fixedMessage = null;
          }
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    checkWriterName(writer) {
      if (writer.lastName || writer.firstName || writer.middleName) {
        return `${writer.lastName}  ${writer.firstName}  ${writer.middleName}`;
      } else {
        return writer.name;
      }
    },

    closeDialog() {
      this.$refs.formFirst.reset();
      this.$refs.formFirst.resetValidation();
      this.selectedUser = {};
      this.dialogBlockUser = false;
    },
    deleteOldMethod() {
      this.blockMessage(this.editMessageItem);

      this.dialogDeleteOldImage = false;
      this.editMessageItem = {
        body: "",
        attachments: [],
      };
      this.oldImage = null;
    },
    blockMessage(item) {
      let bool = null;
      item.status == "blocked_by_admin" ? (bool = false) : (bool = true);

      this.$axios
        .put(
          this.$store.getters.apiAdminPanelV2 + "/club/chat/message/block",
          {
            messageId: item.id,
            toBlock: bool,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((response) => {
          if (response.data?.result == "ok") {
            item.status =
              item.status == "blocked_by_admin"
                ? "not_blocked"
                : "blocked_by_admin";
          }
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    dateBlockGetItems(pack, number) {
      this.isScrolling = true;
      this.showAnswerIcon = false;
      const isScrollingNow = localStorage.getItem("isScroll");
      if (isScrollingNow) {
        clearTimeout(isScrollingNow);
      }

      let itemDate;
      this.viewArray.forEach((element) => {
        if (element.packNumber == pack) {
          element.messages.forEach((el, index) => {
            if (index + 1 == number) {
              itemDate = el;
            }
          });
        }
      });

      if (itemDate) {
        const month = this.$moment(itemDate.dateCreated)
          .format("DD.MM.YYYY")
          .substring(3, 5);
        const day = this.$moment(itemDate.dateCreated)
          .format("DD.MM.YYYY")
          .substring(0, 2);
        const neededMonth = this.monthItems.filter((i) => {
          if (i.number == month) {
            return i;
          }
        });

        this.dateInDateBlock = `${day.replace(/^0+/, "")} ${
          neededMonth[0].name
        }`;
      }

      let stopScroll = setTimeout(() => {
        this.showAnswerIcon = true;
        setTimeout(() => {
          this.isScrolling = false;
        }, 600);
      }, 300);
      localStorage.setItem("isScroll", stopScroll);
    },
    getMessages() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV2 + "/club/chat/message/list", {
          params: {
            chatId: this.$route.params.id,
            userId: this.$store.getters.user.id,
          },
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
        })
        .then((res) => {
          let newArr = [];
          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index];
            element.show = true;
            const newItems = element.messages.map((i) => ({
              ...i,
              answerShow: false,
            }));
            element.messages = newItems;
            newArr.push(element);
            if (index < 2) {
              this.viewArray.push(element);
            }
          }
          this.allPacks = newArr;
          if (this.allPacks.length > 0) {
            this.lastNumberPack =
              this.allPacks[this.allPacks.length - 1].packNumber;
          } else {
            this.lastNumberPack = 1;
            const newObj = {
              packNumber: 1,
              messages: [],
              show: true,
            };
            this.allPacks.push(newObj);
          }

          this.addNumberPacks(this.allPacks);
          const options = {};
          this.observer = new IntersectionObserver(([entry]) => {
            if (entry && entry.isIntersecting) {
              this.dateBlockGetItems(
                parseInt(entry.target.attributes.data_pack.value),
                parseInt(entry.target.attributes.data_number.value)
              );
              this.findNewRead(
                parseInt(entry.target.attributes.data_pack.value),
                parseInt(entry.target.attributes.data_number.value)
              );
            }
          }, options);

          this.setAllPacks();

          this.$nextTick(() => {
            this.findScroll();
            this.addObserver();
          });
        });
    },
    setAllPacks() {
      for (let index = 1; index < this.lastNumberPack; index++) {
        const element = index;
        if (!this.numberPacks.includes(element)) {
          const newObj = {
            messages: [],
            packNumber: element,
            show: false,
          };
          this.allPacks.push(newObj);
        }
      }
      this.allPacks = this.allPacks.sort((a, b) => {
        return a.packNumber - b.packNumber;
      });
    },
    addNumberPacks(list) {
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        if (!this.numberPacks.includes(element.packNumber)) {
          this.numberPacks.push(element.packNumber);
        }
      }
    },

    addObserver() {
      // const elements = this.$refs.message;
      const elements = document.getElementsByClassName("chat-messages-block");
      const pinnedMessage = document.getElementsByClassName("message_pined");

      // const pinnedMessage = this.$refs.message_pined;

      if (pinnedMessage && pinnedMessage[0]) {
        this.observer.observe(pinnedMessage[0]);
      }
      if (elements && elements.length > 0) {
        for (let index = 0; index < elements.length; index++) {
          const element = elements[index];
          this.observer.observe(element);
        }
      }
    },
    sendMessageMethod() {
      this.isSendMessage = true;
      const message = {
        chatId: this.$route.params.id,
        body: this.editMessageItem.id
          ? this.editMessageItem.body.trim()
          : this.sendMessage.body.trim(),
        messageId: this.editMessageItem.id
          ? this.editMessageItem.id
          : this.answerObj
          ? this.answerObj.id
          : "",
        attachments: this.editMessageItem.id
          ? this.editMessageItem.attachments
          : this.sendMessage.attachments,
      };
      let formData = new FormData();
      formData.append("chatId", message.chatId);
      formData.append("body", message.body);
      formData.append("messageId", message.messageId);
      if (message.attachments.length > 0) {
        message.attachments.forEach((element) => {
          if (element.type == "image") {
            formData.append("attachments", element.attachments[0]);
            if (element.resolutions && element.resolutions.length > 0) {
              formData.append(
                "resolutions",
                JSON.stringify(element.resolutions[0])
              );
            }
          } else if (element.type == "transition") {
            const newObj = {
              type: element.type,
              data: element.body,
            };
            formData.append("attachments", JSON.stringify(newObj));
          }
        });
      }

      const url = this.editMessageItem.id
        ? "/club/chat/message/edit"
        : this.answerObj
        ? "/club/chat/message/reply"
        : "/club/chat/message/send";
      const axiosVoid = this.editMessageItem.id
        ? this.$axios.put
        : this.$axios.post;
      axiosVoid(this.$store.getters.apiAdminPanelV2 + url, formData, {
        headers: {
          authorization: this.$store.getters.adminPanelHeaderAuth,
        },
      })
        .then((res) => {
          if (!this.editMessageItem.id) {
            if (this.allPacks.length > 0) {
              res.data.answerShow = false;
              this.allPacks[this.allPacks.length - 1].messages.push(res.data);
            } else {
              const newObj = {
                messages: [],
                packNumber: 1,
              };
              newObj.messages.push(res.data);
              this.allPacks.push(newObj);
            }
            this.$nextTick(() => {
              this.goToBottom();
            });
          }
          this.upadateMess(res);
          this.dialogSendMessage = false;
          this.answerObj = null;
          this.sendMessage = { body: "", attachments: [] };
          this.editMessageItem = { body: "", attachments: [] };
          setTimeout(() => {
            this.isSendMessage = false;
          }, 500);
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
          this.isSendMessage = false;
        });
    },
    addMess(item) {
      item.data.answerShow = false;
      let bool = this.modeAll
        ? true
        : item.data.chatId == this.$route.params.id
        ? true
        : false;
      if (bool) {
        const scrollTop = this.$refs.scrollChats.scrollTop;
        const scrollHeight =
          this.$refs.scrollChats.scrollHeight -
          this.$refs.scrollChats.clientHeight;
        this.allPacks[this.allPacks.length - 1].messages.push(item.data);
        if (scrollTop == scrollHeight) {
          this.$nextTick(() => {
            this.$refs.scrollChats.scrollTo({
              top:
                this.$refs.scrollChats.scrollHeight -
                this.$refs.scrollChats.clientHeight,
            });
          });
        }
      }
    },
    upadateMess(item) {
      const newObj = JSON.parse(JSON.stringify(item));

      this.allPacks = this.allPacks.map((i) => {
        let newArr = i.messages.map((el) => {
          if (el.id == item.data.id) {
            newObj.data.answerShow = false;
            return newObj.data;
          } else {
            return el;
          }
        });
        i.messages = newArr;
        return i;
      });
      this.viewArray = this.viewArray.map((i) => {
        let newArr = i.messages.map((el) => {
          if (el.id == item.data.id) {
            newObj.data.answerShow = false;
            return newObj.data;
          } else {
            return el;
          }
        });
        i.messages = newArr;
        return i;
      });
      this.readVisibleMessages();
    },
    pinNewMess(item) {
      this.fixedMessage = item.data;
    },
    unPinNewMess() {
      this.fixedMessage = null;
    },
    userUpdated(item) {
      const bool = item.data.blocking ? true : false;
      this.blockingUserAllMess(item.data.id, bool);
    },
    openSocket() {
      const token = this.$store.getters.adminPanelHeaderAuth;
      const wsChat = this.$store.getters.wsChatURL;

      let socket = new WebSocket(wsChat);
      socket.addMessage = this.addMess;
      socket.updateMessage = this.upadateMess;
      socket.pinNewMessage = this.pinNewMess;
      socket.unPinNewMessage = this.unPinNewMess;
      socket.userUpdated = this.userUpdated;

      this.connection = socket;
      socket.onopen = function () {
        socket.send(token);
      };
      socket.onmessage = function (event) {
        const soc = JSON.parse(event.data);
        if (soc.tag == "new_message") {
          socket.addMessage(soc);
        } else if (soc.tag == "edited_message") {
          socket.updateMessage(soc);
        } else if (soc.tag == "pin_message") {
          socket.pinNewMessage(soc);
        } else if (soc.tag == "unpin_message") {
          socket.unPinNewMessage();
        } else if (soc.tag == "user_updated") {
          socket.userUpdated(soc);
        }
      };
    },
    async readMessage(id) {
      if (this.lastReadMessageId != id) {
        this.lastReadMessageId = id;
        await this.$axios
          .post(
            this.$store.getters.apiAdminPanelV2 + "/club/chat/message/read",
            {
              messageId: id,
              isAllChats: this.modeAll ? true : false,
            },
            {
              headers: {
                authorization: this.$store.getters.adminPanelHeaderAuth,
              },
            }
          ).then(() => {
            this.firstNotReadMessage = null;
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
    },
    findNewRead(pack, number) {
      let obj;
      this.allPacks.forEach((i) => {
        if (i.packNumber == pack) {
          i.messages.forEach((element, index) => {
            if (index + 1 == number) {
              obj = element;
            }
          });
        }
      });
      if (!obj.isRead) {
        this.readMessage(obj.id);
      }
    },
    getChat() {
      if (!this.modeAll) {
        this.$axios
          .get(this.$store.getters.apiAdminPanelV2 + "/club/chat", {
            params: {
              chatId: this.$route.params.id,
            },
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          })
          .then((res) => {
            this.chat = res.data.chat;
            this.fixedMessage = res.data.chat?.pinnedMessage
              ? res.data.chat.pinnedMessage
              : null;
            this.getMessages();
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      } else {
        this.$axios
          .get(
            this.$store.getters.apiAdminPanelV2 + "/club/chat/message/getAll",
            {
              headers: {
                authorization: this.$store.getters.adminPanelHeaderAuth,
              },
            }
          )
          .then((res) => {
            let newArr = [];
            for (let index = 0; index < res.data.length; index++) {
              const element = res.data[index];
              element.show = true;
              const newItems = element.messages.map((i) => ({
                ...i,
                answerShow: false,
              }));
              element.messages = newItems;
              newArr.push(element);
              if (index < 2) {
                this.viewArray.push(element);
              }
            }
            this.allPacks = newArr;
            if (this.allPacks.length > 0) {
              this.lastNumberPack =
                this.allPacks[this.allPacks.length - 1].packNumber;
            } else {
              this.lastNumberPack = 1;
              const newObj = {
                packNumber: 1,
                messages: [],
                show: true,
              };
              this.allPacks.push(newObj);
            }
            this.addNumberPacks(this.allPacks);
            const options = {};
            this.observer = new IntersectionObserver(([entry]) => {
              if (entry && entry.isIntersecting) {
                this.dateBlockGetItems(
                  parseInt(entry.target.attributes.data_pack.value),
                  parseInt(entry.target.attributes.data_number.value)
                );
                this.findNewRead(
                  parseInt(entry.target.attributes.data_pack.value),
                  parseInt(entry.target.attributes.data_number.value)
                );
              }
            }, options);

            this.setAllPacks();

            this.$nextTick(() => {
              this.findScroll();
              this.addObserver();
            });
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
    },

    scrollToPinedMess() {
      this.isSendMessage = true;
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV2 + "/club/chat/message/pinned",
          {
            params: {
              chatId: this.fixedMessage.chatId,
            },
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          let newArr = [];
          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index];
            const newItems = element.messages.map((i) => ({
              ...i,
              answerShow: false,
            }));
            element.messages = newItems;
            element.show = true;

            for (let ind = 0; ind < this.allPacks.length; ind++) {
              const el = this.allPacks[ind];
              if (element.packNumber == el.packNumber) {
                el.messages = element.messages;
                el.show = true;
              }
            }
            newArr.push(element);
          }
          newArr.sort((a, b) => {
            return b.packNumber - a.packNumber;
          });
          this.viewArray = [];
          for (let index = 0; index < newArr.length; index++) {
            const element = newArr[index];
            this.viewArray.unshift(element);
          }
          this.$nextTick(() => {
            const pinnedMessage =
              document.getElementsByClassName("message_pined");
            this.$refs.scrollChats.scrollTo({
              top: pinnedMessage[0].offsetTop - 20,
            });
            setTimeout(() => {
              this.isSendMessage = false;
            }, 500);
          });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getReasonsBlocks() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/club/blocking/reason/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.reasonsBlock = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    blockingUser(bool) {
      if (this.$refs.formFirst.validate()) {
        this.blockingLoad = true;
        this.$axios
          .post(
            this.$store.getters.apiAdminPanelV2 + "/club/user/blocking",
            {
              toBlock: bool,
              userId: this.selectedUser.userWriter.id,
              reasonId: bool ? this.selectedUser.reasonBlock : "",
            },
            {
              headers: {
                authorization: this.$store.getters.adminPanelHeaderAuth,
              },
            }
          )
          .then(() => {
            this.blockingLoad = false;
            this.blockingUserAllMess(this.selectedUser.userWriter.id, bool);
            this.closeDialog();
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
    },
    blockingUserAllMess(id, bool) {
      for (let index = 0; index < this.allPacks.length; index++) {
        const element = this.allPacks[index];
        if (element.messages.length > 0) {
          for (let ind = 0; ind < element.messages.length; ind++) {
            const el = element.messages[ind];
            if (el.writerId == id) {
              el.userWriter.isBlocked = bool;
            }
          }
        }
      }
    },
    findScroll() {
      const el = document.getElementsByClassName("chat-messages-banner");
      this.loadPack = true;
      if (el && el.length > 0) {
        const element = el[0].getBoundingClientRect();
        this.$refs.scrollChats.scrollTo({ top: element.top - 280 });

        this.loadPack = false;
      } else {
        this.loadPack = false;
        this.$nextTick(() => {
          this.$refs.scrollChats.scrollTo({
            top:
              this.$refs.scrollChats.scrollHeight -
              this.$refs.scrollChats.clientHeight,
          });
        });
      }
      setTimeout(() => {
        this.firstLoadPage = false;
      }, 500);
    },
    goToBottom() {
      this.viewArray = [];
      this.allPacks.forEach((element, index) => {
        if (index == this.allPacks.length - 2) {
          if (element.messages.length > 0) {
            this.viewArray.push(element);
          }
        }
        if (index == this.allPacks.length - 1) {
          this.viewArray.push(element);
        }
      });
      this.$nextTick(() => {
        this.$refs.scrollChats.scrollTo({
          top:
            this.$refs.scrollChats.scrollHeight -
            this.$refs.scrollChats.clientHeight,
        });
      });
    },
  },
  watch: {
    "sendMessage.body"() {
      this.sendMessage.body = this.sendMessage.body.trimStart();
    },
    "editMessageItem.body"() {
      this.editMessageItem.body = this.editMessageItem.body.trimStart();
    },
  },
  created() {
    this.modeAll = this.$route.params.id == "all" ? true : false;
    this.openSocket();
    this.getChat();
    this.getReasonsBlocks();
    this.userRoleEdit = this.roleEditUser("shareholders_club");
    const userAgent = navigator.userAgent.toLowerCase();
    this.chrome = /chrome/.test(userAgent);
  },
  beforeUpdate() {},
  mounted() {
    setTimeout(() => {
    if (this.viewArray.length > 0) {
      this.readVisibleMessages();
    }
    }, 1000);
  },
  destroyed() {
    this.connection.close();
    this.observer.disconnect();
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;

  .main-container-title {
    padding: 24px;
    display: flex;
    height: 90px;
    justify-content: space-between;
    overflow: hidden;

    .main-container-title-text {
      font-size: 28px;
      font-weight: 400;
      margin-left: 40px;
      margin-right: 40px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }

  .container-chat {
    border-top: 1px solid #00000010;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 154px);

    .container-chat-message-fixed {
      width: 100%;
      padding: 16px 24px;
      box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.12);
      display: flex;

      .message-fixed-image {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;

        img {
          width: 40px;
          height: 40px;
          object-fit: cover;
        }
      }

      .message-fixed-title {
        font-size: 18px;
        font-weight: 600;
        color: var(--app-dark-blue-1);
      }

      .message-fixed-text {
        font-size: 16px;
        font-weight: 400;
        max-width: 700px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .container-chat-date-block {
      width: 736px;
      position: relative;

      .date-block {
        opacity: 1;
        transition: 0.5s;
        padding: 4px 20px;
        border-radius: 14px;
        background: white;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
        position: absolute;
        margin-top: 10px;
        left: 50%;
        color: #929292;
      }

      .date-block-hide {
        opacity: 0;
        transition: 0.5s;
        padding: 4px 20px;
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
        position: absolute;
        margin-top: 10px;
        left: 50%;
      }
    }

    .container-chat-messages {
      width: 100%;
      position: relative;
      overflow-y: scroll;

      .chat-messages-bottom {
        width: 32px;
        height: 32px;
        background: #e7eaf1;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: sticky;
        bottom: 22px;
        left: 872px;
        cursor: pointer;
      }
    }

    .container-chat-send-message {
      box-shadow: 0px -4px 9px 0px rgba(0, 0, 0, 0.12);
      padding: 15px 0 20px 30px;

      .send-message-block {
        display: flex;
        align-items: center;

        .send-message-block-input {
          margin-left: 24px;
          margin-right: 40px;
          width: 656px;
          border-radius: 6px;
          background: #e7eaf1;
          padding: 12px 24px;
          outline: none;
          resize: none;
        }
      }

      .send-message-box {
      }

      .send-message-answer {
        display: flex;
        align-items: center;
        margin-left: 0px;
        margin-bottom: 8px;

        .send-message-answer-icon {
          margin-right: 24px;
        }

        .send-message-answer-value {
          margin-right: 26px;
          min-width: 611px;
          border-left: 2px solid #0066e5;
          display: flex;
          align-items: center;

          .answer-value-image {
            margin-left: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            .answer-value-image-icon {
              position: absolute !important;
              z-index: 1 !important;
              left: 50% !important;
              top: 50% !important;
              transform: translate(-50%, -50%) !important;
              display: none !important;
              transition: 0.5s !important;
            }

            img {
              width: 40px;
              height: 40px;
              object-fit: cover;
              transition: 0.5s;
            }
          }

          .answer-value-image:hover {
            img {
              filter: brightness(50%);
              transition: 0.5s;
            }

            .answer-value-image-icon {
              display: block !important;
              transition: 0.5s !important;
            }
          }

          .answer-value-text {
            div:first-child {
              padding-left: 22px;
              color: #1064dd;
              font-size: 16px;
              font-weight: 400;
            }

            div:last-child {
              padding-left: 22px;
              font-size: 16px;
              font-weight: 400;
              max-width: 558px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
}

.contextmenu-chat {
  background: white;

  .contextmenu-chat-item {
    padding: 12px 16px;
    cursor: pointer;
    background: white;
  }

  .contextmenu-chat-item:hover {
    background: #e7eaf1;
  }
}

.dialog-description-icon-block {
  display: flex;
  align-items: center;

  img {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 12px;
  }

  div {
    font-size: 20px;
    font-weight: 600;
  }
}

.dialog-description-img {
  width: 360px;
  height: 200px;
  object-fit: cover;
}

.dialog-buttons-input {
  width: 347px;
  margin-right: 40px;
  border-radius: 6px;
  background: #e7eaf1;
  padding: 8px 24px;
  outline: none;
  resize: none;
}

.dialog-images {
  .dialog-images-object {
    width: 50px;
    height: 50px;
    object-fit: cover;
    margin: 8px;
  }

  .dialog-images-object:first-child {
    margin-left: 0px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-input-enter {
  height: 0px;
  transition: all 0.2s ease;
  opacity: 0;
}

.slide-input-enter-active {
  height: 0px;
  transition: all 0.2s ease;
  opacity: 0;
}

.slide-input-enter-to {
  height: 48px;
  transition: all 0.2s ease;
  opacity: 1;
}

.slide-input-leave {
  height: 48px;
  opacity: 0;
}

.slide-input-leave-active {
  height: 48px;
  transition: all 0.2s ease;
  opacity: 0;
}

.slide-input-leave-to {
  height: 0px;
  transition: all 0.2s ease;
  opacity: 0;
}

.slide-pinned-enter {
  height: 0px;
  transition: all 0.3s ease;
  opacity: 0;
}

.sslide-pinned-enter-to {
  height: 83px;
  transition: all 0.3s ease;
  opacity: 1;
}

.slide-pinned-leave {
  height: 83px;
  opacity: 0;
}

.slide-pinned-leave-active {
  height: 83px;
  transition: all 0.2s ease;
  opacity: 0;
}

.slide-pinned-leave-to {
  height: 0px;
  transition: all 0.2s ease;
  opacity: 0;
}
</style>
